import React from 'react'
import {useField} from 'formik';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    name: string;
}

export const FormCheckbox = (props: Props) => {
    const [field] = useField({ ...props, type: 'checkbox' });
    const { style, className, ...restProps } = props;
    const combinedClassName = ['checkbox-input', className].filter(Boolean).join(' ');
    const labelStyle = { ...style, marginBottom: style?.marginBottom ?? 24 };

    return (
        <label htmlFor={props.name} className={combinedClassName} style={labelStyle}>
            <input type='checkbox' role='switch' {...field} {...restProps} />
            <span style={{fontSize:'16px'}}>{props.label}</span>
        </label>
    );
};

